import styled from 'styled-components'
import CommonRangeSlider from 'common-components/RangeSlider'
import Text from 'common-components/Text'
import FlyoutWithMobileSlideUp from 'components/FlyoutWithMobileSlideUp'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const Flyout = styled(FlyoutWithMobileSlideUp)`
  border-radius: 10px;
  overflow: hidden;
`

export const FlyoutContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${COLORS.white};
`

export const VolumeControlContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 13px 8px;
  width: 40px;
  height: 170px;
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    flex-direction: row-reverse;
    width: 100%;
    height: auto;
    gap: 20px;
  }
`

export const RangeSlider = styled(CommonRangeSlider)`
  width: 120px;
  transform: rotate(-90deg) translateX(45%);
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    transform: none;
    width: auto;
    flex-grow: 1;
  }
`

export const VolumeValue = styled(Text)`
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    font-size: 11px;
    width: 47px;
    height: 30px;
    border: 1px solid ${COLORS.borderColor};
    border-radius: 4px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`

export const MuteButton = styled.button<{ $isMuted: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 32px;
  border: none;
  border-top: 1px solid ${COLORS.borderColor};
  background: ${({ $isMuted }) =>
    $isMuted ? COLORS.primaryLight : COLORS.white};
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;

  & > svg {
    width: 16px;
    height: 16px;
    fill: ${({ $isMuted }) =>
      $isMuted ? COLORS.primaryDark : COLORS.secondarySemiDark};
  }

  &:hover {
    background: ${COLORS.primaryLight};
    & > svg {
      fill: ${COLORS.primaryDark};
    }
  }

  transition: background 0.2s ease;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 4px;
  }
`
